import Activities from '@/components/Activities'
import { getProcessLogs } from '../../services'
import { useParams } from 'react-router-dom'

const ProcessLogs = () => {
    const { id } = useParams<{ id: string }>()

    return (
        <div className="mt-2">
            <Activities
                apiCall={(payload) =>
                    getProcessLogs({ process_id: id!, params: payload })
                }
                queryKey={`process-logs-${id}`}
                translationNamespace="warehouse"
            />
        </div>
    )
}

export default ProcessLogs
